<form [formGroup]="languageProficiencyForm">
  <div class="step-container">
    <ng-template #labelLanguageProficiency>{{ getTranslation('language.title') }}</ng-template>
    

    <div class="step-title">
      {{ isEditable ? getTranslation('language.title') : getTranslation('language.blockedForEdit') }}
      <span *ngIf="!isEditable" class="badge badge-warning ml-2" style="font-size: 0.75rem;">(Read Only)</span>
    </div>

    <div *ngIf="isJsonShow">
      {{languageProficiencyForm.value | json}}
    </div>



<!-- Language Rows -->
<div formArrayName="languages">
  <div *ngFor="let languageForm of languagesArray.controls; let i = index" [formGroupName]="i" class="language-row mb-3 p-3 border rounded">

    <!-- Responsive Row Layout -->
    <div class="row gx-2">
      
      <!-- Language Name -->
      <div class="col-12 col-md-3 mb-3">
        <label [for]="'languageName' + i" class="form-label">
          {{ getTranslation('language.languageName') }} <span class="text-danger">*</span>
      
        </label>
   


        <!-- Use *ngIf with else -->
  <ng-container *ngIf="i < 2; else dropdownLang">
    <!-- First 2 rows = Readonly Input -->
    <input 
      type="text"
      class="form-control"
      [value]="languageForm.get('LanguageName')?.value"
      readonly />
  </ng-container>

  <!-- After 2nd row = Dropdown -->
 

  <!-- After 2nd row = Dropdown -->
<ng-template #dropdownLang>
  <select 
    class="form-control" 
    [id]="'languageName' + i" 
    [class.submitted]="submitted"
    formControlName="LanguageName">
    <option value="">{{ getTranslation('language.selectLanguage') }}</option>
    <option *ngFor="let lang of getAvailableLanguages(i)" 
            [value]="lang.OptionValue">
      {{ lang.OptionText }}
    </option>
  </select>
</ng-template>


  


        <div *ngIf="submitted && languageForm.get('LanguageName')?.invalid" class="text-danger">
          {{ getTranslation('validation.languageNameRequired') }}
        </div>
      </div>

      <!-- Speaking Proficiency -->
      <div class="col-12 col-md-3 mb-3">
        <label [for]="'speaking' + i" class="form-label">
          {{ getTranslation('language.speaking') }} <span class="text-danger">*</span>
        </label>
        <select 
          class="form-control" 
          [id]="'speaking' + i" 
          [class.submitted]="submitted"
          formControlName="SpeakingProficiency">
          <option value="">{{ getTranslation('language.select') }}</option>
          <option *ngFor="let prof of proficiencyOptions" [value]="prof.value">{{prof.label}}</option>
        </select>
        <div *ngIf="submitted && languageForm.get('SpeakingProficiency')?.invalid" class="text-danger">
          {{ getTranslation('validation.speakingRequired') }}
        </div>
      </div>

      <!-- Reading Proficiency -->
      <div class="col-12 col-md-3 mb-3">
        <label [for]="'reading' + i" class="form-label">
          {{ getTranslation('language.reading') }} <span class="text-danger">*</span>
        </label>
        <select 
          class="form-control" 
          [id]="'reading' + i" 
          [class.submitted]="submitted"
          formControlName="ReadingProficiency">
          <option value="">{{ getTranslation('language.select') }}</option>
          <option *ngFor="let prof of proficiencyOptions" [value]="prof.value">{{prof.label}}</option>
        </select>
        <div *ngIf="submitted && languageForm.get('ReadingProficiency')?.invalid" class="text-danger">
          {{ getTranslation('validation.readingRequired') }}
        </div>
      </div>

      <!-- Writing Proficiency -->
      <div class="col-12 col-md-3 mb-3">
        <label [for]="'writing' + i" class="form-label">
          {{ getTranslation('language.writing') }} <span class="text-danger">*</span>
        </label>
        <select 
          class="form-control" 
          [id]="'writing' + i" 
          [class.submitted]="submitted"
          formControlName="WritingProficiency">
          <option value="">{{ getTranslation('language.select') }}</option>
          <option *ngFor="let prof of proficiencyOptions" [value]="prof.value">{{prof.label}}</option>
        </select>
        <div *ngIf="submitted && languageForm.get('WritingProficiency')?.invalid" class="text-danger">
          {{ getTranslation('validation.writingRequired') }}
        </div>
      </div>

      <!-- Delete Button -->
      <div class="col-12 col-md-auto mb-3 d-flex align-items-end justify-content-center" *ngIf="!isRowRequired(i)">
        <button 
          type="button" 
          class="btn btn-outline-danger btn-sm delete-btn" 
          (click)="removeLanguageRow(i)"
          *ngIf="!isPreviewMode"
          [title]="getTranslation('language.delete')">
          <i class="fas fa-trash me-1"></i>{{ getTranslation('language.delete') }}
        </button>
      </div>

    </div>
  </div>
</div>





    <!-- Add New Language Button -->
    <div class="row mb-4" *ngIf="!isPreviewMode && isEditable">
      <div class="col-12">
        <button 
          type="button" 
          class="btn btn-success" 
          (click)="addLanguageRow()">
          <i class="fas fa-plus"></i> {{ getTranslation('language.addNewLanguage') }}
        </button>
      </div>
    </div>

   

  </div>

  
  <!-- Buttons start -->
  <div class="btn-group vendortitle nb-progress-bar margincss mobile-responsive" *ngIf="!isPreviewMode && isEditable">
    <button type="button" class="btn savedraftbtn" 
    *ngIf="languageProficiencyForm.get('SaveMode')?.value !== SaveMode.SAVE"
            (click)="onSubmit(SaveMode.DRAFT)">
      <i class="fas fa-save mr-2"></i>{{ getTranslation('button.saveAsDraft') }}
    </button>
    <button type="button" class="btn prevbtn" (click)="goToBack()">
      <i class="fas fa-arrow-left mr-2"></i>{{ getTranslation('button.previous') }}
    </button>
    <button type="button" class="btn nextbtn" (click)="onSubmit(SaveMode.SAVE)">
      <i class="fas fa-arrow-right mr-2"></i>{{ getTranslation('button.next') }}
    </button>
  </div>
  <!-- Buttons ends -->
</form>
  